module.exports = __webpack_public_path__ + "assets1752041109707/img/logo-block.b2a020b6.png";